// extracted by mini-css-extract-plugin
export default {"wrapper":"FavoriteIcon__wrapper--1XV","actuator":"FavoriteIcon__actuator--3f8","icon":"FavoriteIcon__icon--JP_","featured":"FavoriteIcon__featured--2t_","on":"FavoriteIcon__on--RAy"};